<ng-container *ngIf="complementaryReport != null">
    <h1 *ngIf="complementaryReport.showTitleInReport!==false" stylePreference [textColor]="stylePreferenceOptions?.textColor">{{ complementaryReport.title }}</h1>
    <div *ngIf="complementaryReport.showTitleInReport===false" class="hidden-spacer"></div>
    <div class="{{markerClasses.COMPLEMENTARY_REPORT}}{{ reportIndex }}">
        <aumico-annualReport-complementary-report-german-display-component
            [complementaryReportContent]="complementaryReport.data"
            [backgroundColor]="stylePreferenceOptions.backgroundColor"
            [textColor]="stylePreferenceOptions.textColor"
        ></aumico-annualReport-complementary-report-german-display-component>
        <ng-container *ngIf="complementaryReport.fileId">
            <div class="file-info-wrapper">
                <span
                    class="extension-icon"
                    hamIconShapes
                    icon="assets/hamIcons/pdf.svg"
                    [size]="'20px'"
                    [variant]="'transparent'"
                ></span>
                <div class="file-info-text">
                    <ng-container>{{ decodeFileName(complementaryReport?.fileName) }}</ng-container>
                </div>
                <ham-button
                    type="submit"
                    size="xs"
                    outline="true"
                    icon="assets/hamIcons/eye-outline.svg"
                    (buttonClick)="onPreviewRequested(complementaryReport?.fileId)"
                    >{{ 'aumico_annual_report_complementary_reports_preview_button' | i18next }}
                </ham-button>
            </div>
        </ng-container>
    </div>
</ng-container>

<ham-modal
    *ngIf="isPreviewModalOpen"
    [title]="complementaryReport?.fileName"
    [size]="'default'"
    (cancel)="onClosePreviewModal()"
    hideFooter="true"
>
    <div class="flyout-preview-content">
        <ng-container *ngIf="complementaryReportPreviews[complementaryReport?.fileId]?.previewUrl">
            <img
                [src]="complementaryReportPreviews[complementaryReport?.fileId]?.previewUrl"
                alt="Document Preview"
                class="preview-image"
            />
        </ng-container>
        <ng-container *ngIf="!complementaryReportPreviews[complementaryReport?.fileId]?.previewUrl">
            <div class="no-preview-message">
                <div>
                    {{ getPreviewStatusText(complementaryReportPreviews[complementaryReport?.fileId]?.previewStatus) }}
                </div>
                <div
                    class="warning-message"
                    *ngIf="complementaryReportPreviews[complementaryReport?.fileId]?.previewStatus === 'scanning'"
                >
                    {{ 'aumico_annual_report_complementary_reports_preview_scanning_warning' | i18next }}
                </div>
            </div>
        </ng-container>
    </div>
</ham-modal>
